import { feedbackUIAvailabilityAtom } from '@atoms';
import { APP_NAME, FEEDBACK_UI } from '@utils/constants';
import { ErrorBoundary } from 'fe-core';
import { useCheckServiceAvailability } from 'fe-core-events';
import { useAtom } from 'jotai';
import { ReactElement, useEffect, useRef } from 'react';
import { useErrorMap } from '@fe-learner-common/hooks/useErrorMap';

type ErrorGuardProps = {
  children: ReactElement;
};

export const ErrorGuard = ({ children }: ErrorGuardProps) => {
  const errorMap = useErrorMap();
  const [feedbackUIAvailability, setFeedbackAvailability] = useAtom(
    feedbackUIAvailabilityAtom,
  );
  const availability = useCheckServiceAvailability({
    serviceId: FEEDBACK_UI,
  });

  const isAtomSet = useRef(false);

  useEffect(() => {
    if (!isAtomSet.current && availability !== null) {
      setFeedbackAvailability(availability === false ? false : true);
      isAtomSet.current = true;
    }
  }, [availability, setFeedbackAvailability]);

  return (
    <ErrorBoundary
      consumerApp={APP_NAME}
      feedbackUIAvailability={feedbackUIAvailability}
      errorMap={errorMap}
      errorMapOverride={{ type: 'modal' }}
    >
      {children}
    </ErrorBoundary>
  );
};
